export default function () {
  return {
    declarationsPreview: [],
    declarations: [],
    isLoadingDeclarationsPreview: false,
    isLoadingDeclarations: false,
    declarationForm: undefined,
    attachmentReadability: undefined,
    customers: [],
    isLoadingCustomers: false,
    isSavingDeclarations: false,
  };
}
